export function formatPrice(price, currency = "USD", transaction = "sale") {
  const n = Number(price) || 0;
  const str = new Intl.NumberFormat("en-US", {
    style: "currency", currency, maximumFractionDigits: 0,
  }).format(n);
  return str;
}

export const PROPERTY_TYPES = [
  "house", "apartment", "condo", "villa", "penthouse", "commercial", "land", "development",
];

export const AMENITIES = [
  "Pool", "Waterfront", "Gym", "Smart Home", "Garden", "Pet Friendly",
  "Concierge", "Elevator", "Fireplace", "Dock", "Solar", "Cinema",
];

export function typeLabel(t, lang) {
  const map = {
    house: { en: "House", es: "Casa" },
    apartment: { en: "Apartment", es: "Apartamento" },
    condo: { en: "Condo", es: "Condominio" },
    villa: { en: "Villa", es: "Villa" },
    penthouse: { en: "Penthouse", es: "Penthouse" },
    commercial: { en: "Commercial", es: "Comercial" },
    land: { en: "Land", es: "Terreno" },
    development: { en: "Development", es: "Desarrollo" },
  };
  return map[t]?.[lang] || t;
}

export const PLACEHOLDER_IMG = "https://images.pexels.com/photos/30211366/pexels-photo-30211366.jpeg?auto=compress&cs=tinysrgb&w=1200&h=800&dpr=2";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function img(url) {
  const s = url ? String(url).trim() : "";
  if (!s) return PLACEHOLDER_IMG;
  // uploaded media are stored as relative "/api/uploads/..." paths
  if (s.startsWith("/api/")) return `${BACKEND_URL}${s}`;
  return s;
}

export function isVideo(url) {
  return /\.(mp4|webm|mov|m4v|ogg)(\?|$)/i.test(String(url || ""));
}

export function statusColor(status) {  return {
    active: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    sold: "bg-red-500/15 text-red-400 border-red-500/30",
    rented: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    pending: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    draft: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
  }[status] || "bg-zinc-500/15 text-zinc-400 border-zinc-500/30";
}
